<span [class]="'badge badge-' + colorClass">{{
    'payment-state.' + PaymentState[state] | translate
}}</span>
